<!-- eslint-disable max-len -->
<template>
<svg
    id="Layer_1" version="1.1" xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 55.2 55.2"
>
    <path
        d="M12.6,24.8c-1.5,1.5-1.5,4.1,0,5.6l23.7,23.7c1.5,1.5,4.1,1.5,5.6,0s1.5-4.1,0-5.6L21,27.6L41.9,6.7c1.5-1.5,1.5-4.1,0-5.6s-4.1-1.5-5.6,0L12.6,24.8L12.6,24.8z" fill="currentColor"
    />
</svg>
</template>
